import { isEmpty } from 'lodash'
import React from 'react'
import { z } from 'zod'

const propsSchema = z.object({
  title: z.string(),
  value: z
    .string()
    .array()
    .or(
      z.object({
        max: z.coerce.number(),
        min: z.coerce.number(),
      })
    ),
})

export type Props = z.infer<typeof propsSchema> & {
  onRemove: () => void
}

export default function AdvanceFilterItem({ title, value, onRemove }: Props) {
  if (Array.isArray(value)) {
    if (isEmpty(value)) return
  }

  if (!Array.isArray(value)) {
    if (value.min === 0 && value.max === 100) return
    if (value.min === 0 && value.max === 0) return
  }

  return (
    <div className="flex items-center gap-1 rounded-2xl border border-primary h-6 text-xs pl-2">
      <p className="font-semibold truncate whitespace-nowrap">{title}</p>
      <FilterItemValue value={value} />
      <div
        className="h-6 w-6 flex items-center justify-center cursor-pointer"
        onClick={() => onRemove()}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.29983 7.99996L4 4.70013L4.94281 3.75732L8.24264 7.05716L11.5425 3.75732L12.4853 4.70013L9.18545 7.99996L12.4853 11.2998L11.5425 12.2426L8.24264 8.94277L4.94281 12.2426L4 11.2998L7.29983 7.99996Z"
            fill="#00AC9C"
          />
        </svg>
      </div>
    </div>
  )
}

const FilterItemValue = ({
  value,
}: {
  value: string[] | { max: number; min: number }
}) => {
  if (Array.isArray(value)) {
    if (value.length === 1) {
      return <p className="max-w-[100px] truncate">{value[0]}</p>
    }
    return <p className="truncate whitespace-nowrap">{value.length} selected</p>
  }

  return (
    <div className="flex items-center flex-row gap-2 truncate whitespace-nowrap">
      <p>
        {value.min}
        <span>-</span>
        <span>{value.max}</span>
      </p>
    </div>
  )
}
